<div class="info tooltip">
    <img src="assets/helpicon.svg" alt="" style="width: 17px;margin-top: 3px;">
    <div class="right">
        <div class="helpData" *ngFor="let item of helpData">
          <div class="headLabel">
            {{item.head}}
          </div>
          <div class="data">
            {{item.data}}
          </div>
        </div>
        <div class="helpData" *ngFor="let item of helpTable">
          <div class="headLabel">
            {{item.head}}
          </div>
          <div class="data">
            <table mat-table  [dataSource]="item.tableArr" class="helpTable">

              <ng-container *ngFor="let column of item.columnsToDisplay" matColumnDef="{{column}}">
                <th mat-header-cell *matHeaderCellDef > {{column}} </th>
                <td mat-cell *matCellDef="let element" >{{element[column]}}</td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="item.columnsToDisplay; sticky: true" style="font-weight: bold !important;"></tr>
              <tr mat-row *matRowDef="let row; columns: item.columnsToDisplay;"></tr>
          </table>
          </div>
        </div>
        <div class="helpData" *ngFor="let item of helpImage">
          <div class="headLabel">
            {{item.head}}
          </div>
          <div class="data">
            <img src="{{item.source}}" alt="" style="width: 300px;">
          </div>
        </div>
        <div class="helpData" *ngFor="let item of helpVideo">
          <div class="headLabel">
            {{item.head}}
          </div>
          <div class="data">
            <video src="{{item.source}}" controls width="500" style="outline: none;">

            </video>
          </div>
        </div>

        <i></i>
    </div>
</div>
